import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.002 2L3.00195 2.00002C2.44967 2.00002 2.00195 2.44774 2.00195 3.00002V13.0358C2.00195 13.5881 2.44967 14.0358 3.00195 14.0358H5.65157C6.12143 14.0358 6.57629 14.2012 6.93638 14.503L9.00143 16.2341L11.0997 14.4957C11.4585 14.1984 11.9098 14.0358 12.3757 14.0358L15.002 14.0358C15.5542 14.0358 16.002 13.588 16.002 13.0358V3C16.002 2.44772 15.5542 2 15.002 2ZM3.00195 2.00272e-05L15.0019 0C16.6588 -2.74181e-06 18.002 1.34314 18.002 3V13.0358C18.002 14.6926 16.6588 16.0357 15.002 16.0358L12.3757 16.0358L9.63566 18.3058C9.26392 18.6138 8.72523 18.6123 8.35528 18.3021L5.65157 16.0358H3.00195C1.3451 16.0358 0.00195312 14.6926 0.00195312 13.0358V3.00002C0.00195312 1.34317 1.34509 2.2769e-05 3.00195 2.00272e-05ZM6.29265 5.29289C6.68317 4.90237 7.31634 4.90237 7.70686 5.29289L8.99976 6.58578L10.2926 5.29289C10.6832 4.90237 11.3163 4.90237 11.7069 5.29289C12.0974 5.68341 12.0974 6.31658 11.7069 6.7071L10.414 8L11.7069 9.29289C12.0974 9.68341 12.0974 10.3166 11.7069 10.7071C11.3163 11.0976 10.6832 11.0976 10.2926 10.7071L8.99976 9.41421L7.70686 10.7071C7.31634 11.0976 6.68317 11.0976 6.29265 10.7071C5.90212 10.3166 5.90212 9.68341 6.29265 9.29289L7.58554 8L6.29265 6.7071C5.90212 6.31658 5.90212 5.68341 6.29265 5.29289Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }